import { cn } from '@/lib/utils'

type IconProps = { className?: string }

export function KpiCalendarIcon({ className }: IconProps) {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={cn('size-4 shrink-0', className)}
      aria-hidden
    >
      <path
        d='M10.6667 1.33337V4.00004M5.33333 1.33337V4.00004M2 6.66671H14M3.33333 2.66671H12.6667C13.403 2.66671 14 3.26366 14 4.00004V13.3334C14 14.0698 13.403 14.6667 12.6667 14.6667H3.33333C2.59695 14.6667 2 14.0698 2 13.3334V4.00004C2 3.26366 2.59695 2.66671 3.33333 2.66671Z'
        stroke='#2550CC'
        strokeWidth='1.6'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export function KpiEuroIcon({ className }: IconProps) {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={cn('size-4 shrink-0', className)}
      aria-hidden
    >
      <path
        d='M10.9211 12.8289C10.0138 12.8298 9.12387 12.581 8.34856 12.1099C7.57325 11.6388 6.94247 10.9635 6.52526 10.1579H10.9211L11.6842 8.63158H6.02158C5.98342 8.37974 5.96053 8.1279 5.96053 7.86842C5.96053 7.60895 5.98342 7.35711 6.02158 7.10526H10.9211L11.6842 5.57895H6.52526C6.94315 4.7739 7.57408 4.09907 8.34923 3.62805C9.12439 3.15703 10.014 2.90793 10.9211 2.9079C12.1497 2.9079 13.2792 3.35816 14.1492 4.10605L15.5 2.75526C14.2432 1.62417 12.6119 0.998838 10.9211 1C7.92947 1 5.39579 2.91553 4.44947 5.57895H1.76316L1 7.10526H4.09842C4.0369 7.61218 4.0369 8.12467 4.09842 8.63158H1.76316L1 10.1579H4.44947C5.39579 12.8213 7.92947 14.7368 10.9211 14.7368C12.6839 14.7368 14.2866 14.0729 15.5 12.9816L14.1416 11.6308C13.2792 12.3787 12.1574 12.8289 10.9211 12.8289Z'
        fill='#FA541C'
      />
    </svg>
  )
}

export function KpiBarChartIcon({ className }: IconProps) {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={cn('size-4 shrink-0', className)}
      aria-hidden
    >
      <path
        d='M8 13.3333V6.66663M12 13.3333V2.66663M4 13.3333V10.6666'
        stroke='#059669'
        strokeWidth='1.6'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export function KpiAlertIcon({ className }: IconProps) {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={cn('size-4 shrink-0', className)}
      aria-hidden
    >
      <path
        d='M8.00004 5.33337V8.00004M8.00004 10.6667H8.00671M14.6667 8.00004C14.6667 11.6819 11.6819 14.6667 8.00004 14.6667C4.31814 14.6667 1.33337 11.6819 1.33337 8.00004C1.33337 4.31814 4.31814 1.33337 8.00004 1.33337C11.6819 1.33337 14.6667 4.31814 14.6667 8.00004Z'
        stroke='#B91C1C'
        strokeWidth='1.6'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export function KpiArrowRightIcon({ className }: IconProps) {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={cn('size-4 shrink-0', className)}
      aria-hidden
    >
      <path
        d='M3.33333 8H12.6667M8 3.33333L12.6667 8L8 12.6667'
        stroke='currentColor'
        strokeWidth='1.6'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export function KpiTrendingUpIcon({ className }: IconProps) {
  return (
    <svg
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={cn('size-3 shrink-0', className)}
      aria-hidden
    >
      <path
        d='M1 8.5L4 5.5L6 7.5L11 2.5M7.5 2.5H11V6'
        stroke='currentColor'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export function KpiTrendingDownIcon({ className }: IconProps) {
  return (
    <svg
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={cn('size-3 shrink-0', className)}
      aria-hidden
    >
      <path
        d='M1 3.5L4 6.5L6 4.5L11 9.5M7.5 9.5H11V6'
        stroke='currentColor'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export function KpiStatusDotIcon({ className }: IconProps) {
  return (
    <svg
      width='4'
      height='4'
      viewBox='0 0 4 4'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={cn('size-1 shrink-0', className)}
      aria-hidden
    >
      <circle cx='2' cy='2' r='2' fill='#8F95A6' />
    </svg>
  )
}
